module.exports = __webpack_public_path__ + "img/reference16.f6662b98.jpg";